import { useEffect, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { FormModel } from '../../../models/form/form';
import { OrganizationModel } from '../../../models/organization/organization';
import { getPublicFormDetailsById } from '../../../services/form/FormService';

const useForm = (formId?: string | undefined) => {
  const [id, setFormId] = useState(formId);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [form, setForm] = useState<FormModel>();
  const [organization, setOrganization] = useState<OrganizationModel>();

  useEffect(() => {
    if (!id) {
      // TODO Set invalid properties
      return;
    }
    setIsLoading(true);
    loadAsync();
  }, [id]);

  const loadAsync = async () => {
    try {
      const formDetails = await getPublicFormDetailsById(id);
      const { form, organization } = formDetails.data;

      const formResult: FormModel = {
        ...form,
        content: JSON.parse(form.content),
      };

      setForm(formResult);
      setOrganization(organization);
    } catch (error) {
      handleError(error);
    }

    setIsLoading(false);
  };

  return { form, organization, setFormId, isLoading, setForm };
};

export default useForm;
